jQuery(document).on("page.ready", function () {
  $ = jQuery;

  if ($(".projects-overview").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    // if (!isMobile) {
    //   $(window).load(function () {
    //     $("#width_tmp_option").html($("#resizing_select option:selected").text());
    //     $("#resizing_select").width($("#width_tmp_select").width());
    //   });

    //   $("#resizing_select").change(function () {
    //     $("#width_tmp_option").html($("#resizing_select option:selected").text());
    //     $(this).width($("#width_tmp_select").width());
    //   });
    // }

    $(".filter-by-toggle").click(function () {
      $(this).toggleClass("open");
      $(".filters-toggle-contain").slideToggle();

      if ($(this).hasClass("open")) {
        $(this).text("Close");
      } else {
        $(this).text("Filter By");
      }
    });

    var post_type;
    var category;

    // Multicheckbox select
    var checkboxes = $(".project-checkboxes input[type=checkbox][name=project-multiselect]");
    var enabledSettings = ["all"];

    // Attach a change event handler to the checkboxes.
    checkboxes.change(function () {
      if (this.value != "all") {
        // Remove checked from "All" checkbox
        $(".project-checkboxes input[type=checkbox][value=all]").prop("checked", false);

        enabledSettings = checkboxes
          .filter(":checked") // Filter out unchecked boxes.
          .map(function () {
            // Extract values using jQuery map.
            return this.value;
          })
          .get(); // Get array.
      } else {
        $(".project-checkboxes input[type=checkbox]").not("[value=all]").prop("checked", false);
        enabledSettings = ["all"];
      }

      loadmore_params.current_page = 1;

      post_type = $(".post-filter-nav").attr("data-post_type");

      var business = $("#selector-business").attr("data-selected-type");
      var service = JSON.stringify(enabledSettings);
      var location = $("#selector-location").attr("data-selected-type");

      $(".loadmore").show();

      if ($(".no-mas").length) {
        $(".no-mas").hide();
      } else {
        $(".no-mas").show();
      }

      if (category == "all") {
        category = "all";
      }

      data = {
        action: "filterposts",
        // category: category,
        business: business,
        service: service,
        location: location,
        post_type: post_type,
      };

      $.ajax({
        url: loadmore_params.ajaxurl,
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          $(".load-cats.loading-dots").show();
        },
        success: function (data) {
          $(".loading-dots").hide();
          if (data) {
            $(".blogpost-container").html(data.posts);
          } else {
            $(".blogpost-container").html("No posts found.");
          }
        },
      });
    });

    // Filter Posts by Category on Select Change
    $(".projects-selector").each(function (index, el) {
      $(el).change(function (e) {
        loadmore_params.current_page = 1;

        post_type = $(el).parents(".post-filter-nav").attr("data-post_type");
        category = $(el).val();

        $(el).parents(".projects-selector-contain").attr("data-selected-type", category);

        var business = $("#selector-business").attr("data-selected-type");
        var service = JSON.stringify(enabledSettings);
        var location = $("#selector-location").attr("data-selected-type");

        $(".loadmore").show();

        if ($(".no-mas").length) {
          $(".no-mas").hide();
        } else {
          $(".no-mas").show();
        }

        if (category == "all") {
          category = "all";
        }

        data = {
          action: "filterposts",
          // category: category,
          business: business,
          service: service,
          location: location,
          post_type: post_type,
        };

        $.ajax({
          url: loadmore_params.ajaxurl,
          data: data,
          type: "POST",
          beforeSend: function (xhr) {
            $(".load-cats.loading-dots").show();
          },
          success: function (data) {
            $(".loading-dots").hide();
            if (data) {
              $(".blogpost-container").html(data.posts);
            } else {
              $(".blogpost-container").html("No posts found.");
            }
          },
        });
      });
    });

    // Checks the Current Cat in category.php
    if (typeof currentCat !== "undefined") {
      if (!category) {
        category = currentCat;
      }
    }

    // Load more posts on Button Click

    $(".loadmore").click(function (e) {
      e.preventDefault();

      post_type = $(".filter-nav-container .post-filter-nav").attr("data-post_type");

      var business = $("#selector-business").attr("data-selected-type");
      var service = JSON.stringify(enabledSettings);
      var location = $("#selector-location").attr("data-selected-type");

      var button = $(this),
        data = {
          action: "loadmore",
          query: loadmore_params.posts, // that's how we get params from wp_localize_script() function
          page: loadmore_params.current_page,
          // category: category,
          business: business,
          service: service,
          location: location,
          post_type: post_type,
        };

      $.ajax({
        // you can also use $.post here
        url: loadmore_params.ajaxurl, // AJAX handler
        data: data,
        type: "POST",
        // type: 'JSON',
        beforeSend: function (xhr) {
          $(".load-more.loading-dots").show();
          button.hide();
        },
        success: function (data) {
          if (data) {
            $(".blogpost-container").append(data);
            loadmore_params.current_page++;
            button.show();

            if (loadmore_params.current_page == loadmore_params.max_page) {
              button.hide(); // if last page, remove the button
            }
          } else {
            button.hide(); // if no data, remove the button as well
            $(".load-more-container").append('<p class="no-mas sub-title">That\'s all folks!</p>');
          }

          $(".load-more.loading-dots").hide();
        },
        complete: function (data) {
          if (data) {
            setTimeout(function () {
              if (loadmore_params.current_page == max_posts_total) {
                button.hide();
              }
            }, 225);
          }
        },
      });
    });

    $(".cat-name").click(function () {
      $(".loadmore").show();
    });
  }
});
